import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import {
    CadastrarMotivoNaoProcedenciaController,
    EditarMotivoNaoProcedenciaController,
} from "../../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import { IListarMotivoParalisarNaoProcedencia } from "../../../../../../Interfaces/AssistenciaTecnica/Atendimento/MotivoNaoProcedencia/MotivoNaoProcedencia";
import UnForm from "../../../../../Form";

interface ICreateUpdateMotivoNaoProcedenciaProps {
    motivoNaoProcedencia?: IListarMotivoParalisarNaoProcedencia;
    onSave?: () => void;
}

export default function CreateUpdateMotivoNaoProcedencia(
    props: ICreateUpdateMotivoNaoProcedenciaProps
) {
    function CreateUpdateMotivoNaoProcedenciaSubmit(
        formData: IListarMotivoParalisarNaoProcedencia
    ) {
        let promise: Promise<IListarMotivoParalisarNaoProcedencia[]>;
        if (props.motivoNaoProcedencia) {
            promise = EditarMotivoNaoProcedenciaController({
                ...formData,
                DS_MOTIVO_NAO_PROCEDENCIA:
                    formData.DS_MOTIVO_NAO_PROCEDENCIA ?? "",
                ID_ETAPA_TIPO_CASO:
                    props.motivoNaoProcedencia.ID_ETAPA_TIPO_CASO ?? 0,
                ID_MOTIVO_NAO_PROCEDENCIA:
                    props.motivoNaoProcedencia.ID_MOTIVO_NAO_PROCEDENCIA ?? 0,
            });
        } else {
            promise = CadastrarMotivoNaoProcedenciaController({
                ...formData,
                DS_MOTIVO_NAO_PROCEDENCIA: formData.DS_MOTIVO_NAO_PROCEDENCIA,
            });
        }

        promise.then(() => {
            props.onSave?.();
        });
    }

    return (
        <div>
            {!props.motivoNaoProcedencia && (
                <h5 className="text-center">
                    Cadastre um Motivo Não Procedência
                </h5>
            )}
            <UnForm
                handleSubmit={CreateUpdateMotivoNaoProcedenciaSubmit}
                className="row"
            >
                <UnForm.Input
                    name="DS_MOTIVO_NAO_PROCEDENCIA"
                    wrapperClassName="col-12 my-2"
                    label="Motivo Não Procedência"
                    defaultValue={
                        props.motivoNaoProcedencia?.DS_MOTIVO_NAO_PROCEDENCIA
                    }
                />

                <UnForm.SubmitButton
                    color={props.motivoNaoProcedencia ? "primary" : "success"}
                    icon={props.motivoNaoProcedencia ? faEdit : faPlus}
                    className="w-100"
                >
                    {props.motivoNaoProcedencia ? "Editar" : "Cadastrar"}
                </UnForm.SubmitButton>
            </UnForm>
        </div>
    );
}
